<template>
    <stripe-button
        :success-url="successUrl"
        :cancel-url="cancelUrl"
        v-slot:default="{ isReady, changeProduct, submit, processing, selected }"
        @error="handleError"
    >
        <form>
            <div class="grid-x grid-margin-x">
                <div class="cell small-12 medium-auto">
                    <select @change="changeProduct">
                        <option value>Please select date</option>
                        <option
                            v-for="product in products"
                            :key="product.value"
                            :value="product.value"
                            v-text="product.name"
                        ></option>

                    </select>
                </div>
                <div class="cell small-12 medium-shrink">
                    <button
                        type="button"
                        class="button"
                        @click="submit"
                        :class="{ disabled: !selected }"
                    >
                        <span v-if="processing"><i class="fas fa-spinner fa-spin fa-fw"></i> </span> <slot></slot>
                    </button>
                </div>
            </div>
        </form>
    </stripe-button>
</template>
<script>
    export default {
        props: {
            products: {
                type: Array,
                default: () => [],
            },
            successUrl: {
                type: String,
                default: window.location.href,
            },
            cancelUrl: {
                type: String,
                default: window.location.href,
            }
        },
        methods: {
            handleError(message) {
                EventHandler.fire('top-warning', {
                    id: 1,
                    message: message || 'Invalid request'
                });
            }
        }
    }
</script>